import React from 'react';
import './App.css';
import person from './other/person.jpg';

const Main = () => {
  const phoneNumber = '+48 513 034 180';

  const handleCall = () => {
    window.location.href = `tel:${phoneNumber.replace(/ /g, '')}`;
  };

  return (
    <section className="Main">
      <div className="Mechanic">
        <img src={person} alt="Przemysław Sikora - Serwis AGD" />
      </div>
      <br></br>
      <div className="ContactInfo">
        <h1>Przemysław Sikora</h1>
        <h2>Profesjonalna naprawa pralek w Krakowie</h2>
        <div className="benefits">
          <p>✓ Dojazd na terenie Krakowa - GRATIS</p>
          <p>✓ Diagnoza - tylko 100 zł</p>
          <p>✓ Szybki termin realizacji</p>
          <p>✓ Gwarancja na wykonane usługi</p>
          <p>✓ Wieloletnie doświadczenie</p>
        </div>
        <br></br>
        <button onClick={handleCall}>
          <span className="phone-icon">📞</span> Zadzwoń teraz: {phoneNumber}
        </button>
      </div>
    </section>
  );
}

export default Main;
